export default __webpack_public_path__ + "static/media/trimmer.291049d6.png";